import request from 'superagent';
import Promise from 'bluebird';
import piction from '../../utils/piction';

export const formatDate = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
};

export const validate = ({ dateFrom, dateTo, umoID, categoryID }) => {
  if (dateFrom && dateTo && dateFrom.getTime() > dateTo.getTime()) {
    return 'Invalid date range';
  }
  if ((!umoID && !categoryID) || (umoID && categoryID)) {
    return 'Please either enter UMO ID or select Category ID';
  }
  return '';
};

export const generateRequestBody = ({ dateFrom, dateTo, umoID, categoryID }, body) => {
  const _body = { ...body };
  if (dateFrom) {
    _body.DATE_FROM = formatDate(dateFrom);
  }
  if (dateTo) {
    _body.DATE_TO = formatDate(dateTo);
  }
  if (umoID) {
    _body.UMO_ID = umoID;
  }
  if (categoryID) {
    _body.CATEGORY_PK = categoryID;
  }
  return _body;
};

export const fetchHistory = async (query, pageStart, pageSize) => {
  const body = { PAGE_SIZE: pageSize, PAGE_START: pageStart, ORDER_BY: 'DATE' };
  const data = generateRequestBody(query, body);
  try {
    return await piction.request('NWS_HISTORY', data, {
      useJSON: true,
    });
  } catch (err) {
    console.error(err);
  }
};

export function downloadCSV(callData) {
  const processedCallData = { ...callData };
  processedCallData.SURL = piction.session._surl || '';
  processedCallData.CSRF = piction.session._token;
  const postURL = piction.jsonURL;
  return new Promise((resolve, reject) => {
    request
      .post(postURL)
      .type('form')
      .send(processedCallData)
      .end((err, res) => {
        if (err) {
          reject(err);
        } else {
          // console.log(res)
          const url = window.URL.createObjectURL(new Blob([res.text]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'edit-history.csv');
          document.body.appendChild(link);
          link.click();
          resolve(true);
        }
      });
  });
}
